import { render, staticRenderFns } from "./ReferralEmployeeAdd.vue?vue&type=template&id=6a27437d"
import script from "./ReferralEmployeeAdd.vue?vue&type=script&lang=js"
export * from "./ReferralEmployeeAdd.vue?vue&type=script&lang=js"
import style0 from "./ReferralEmployeeAdd.vue?vue&type=style&index=0&id=6a27437d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports